{
  "confirmPassword": {
    "match": "Passwords do not match",
    "required": "Confirm password field is required"
  },
  "email": {
    "invalid": "Invalid email",
    "required": "Email field is required"
  },
  "firstName": {
    "required": "First name field is required"
  },
  "lastName": {
    "required": "Last name field is required"
  },
  "password": {
    "minLength": "Password must be at least 12 characters long",
    "lowercase": "Password must contain at least one lowercase letter",
    "number": "Password must contain at least one number",
    "required": "Password field is required",
    "special": "Password must contain at least one special character",
    "uppercase": "Password must contain at least one uppercase letter"
  },
  "phone": {
    "invalid": "Invalid phone number",
    "smsHint": "Invalid number for sending SMS! Enter a French mobile number starting with 06 or 07..."
  },
  "minLength": "This field must contain at least {min} characters",
  "maxLength": "This field must not exceed {max} characters",
  "positiveInt": "Value must be greater than 0",
  "required": "This field is required",
  "requiredSelection": "Select at least one value"
}
